export enum MeetingType {
  DHARMA_MEETING = 'DHARMA_MEETING', // 전법활동가법회
  PRACTICE_MEETING = 'PRACTICE_MEETING', // 수행법회
  BRANCH_MEETING = 'BRANCH_MEETING', // 지부장회의
  GROUP_MEETING = 'GROUP_MEETING', // 지부모둠장회의
}

export enum PracticeType {
  GRATITUDE_PRACTICE = 'GRATITUDE_PRACTICE', // 천일결사수련
  ENLIGHTENMENT_HALL = 'ENLIGHTENMENT_HALL', // 깨달음의 장
  SHARING_HALL = 'SHARING_HALL', // 나눔의 장
  OFFLINE_MEDITATION = 'OFFLINE_MEDITATION', // 오프라인 명상
  ONLINE_MEDITATION = 'ONLINE_MEDITATION', // 온라인 명상
  PRAYER_PRACTICE = 'PRAYER_PRACTICE', // 기도 수련
  MEDITATION_PRACTICE = 'MEDITATION_PRACTICE', // 온라인주말명상
  /* 아래처럼 나눠야 */
  BASIC_MEDITATION = 'BASIC_MEDITATION', // 기본명상
  ADVANCED_MEDITATION = 'ADVANCED_MEDITATION', // 심화명상
}

export enum CompletionStatus {
  COMPLETED = 'COMPLETED', // 수료
  NOT_COMPLETED = 'NOT_COMPLETED', // 미수료
}

export enum AssessmentResult {
  APPROVED = '승인', // 승인
  NOT_APPROVED = '미승인', // 미승인
  PENDING = '승인대기', // 승인대기중
}

export enum ActivityStatus {
  ACTIVE = 'ACTIVE', // 정상
  INACTIVE = 'INACTIVE', // 비활성
  COMPLETED = 'COMPLETED', // 완료
}

export enum ActivityMenuTitle {
  TRAINING_HISTORY = '수련 이력',
  EDUCATION_HISTORY = '교육연수 이력',
  QUALIFICATION_HISTORY = '자격심사 이력',
  REGULAR_ACTIVITY_HISTORY = '정기활동 이력',
  REGULAR_MEETING_ATTENDANCE = '정기회의출석 (추후제공)',
}

export enum PageTitle {
  INVITE_INPUT = '행사 등록하기',
  INVITE_INPUT_PROCESS = '행사 등록하기',
  JT_DHARMA_TALK_QUESTION = '법회질문신청(1/2)',
  JT_DHARMA_TALK_QUESTION_PROCESS = '법회질문신청(2/2)',
  JT_INVITE_GUEST_INPUT = '방문자등록 및 문자발송',
  JT_BOARD_REPLY_FORM = '답변하기',
  JT_BOARD_REPLY_MODIFY_FORM = '답변수정하기',
  JT_INQUIRY_MANAGE = '문의사항관리',
  JT_SYSTEM_MANAGE_FORM = '[시스템] 답변하기',
  JT_SYSTEM_MANAGE_MODIFY_FORM = '[시스템] 답변수정하기',
  PROFILE = '내 정보',
  JT_MEET_NOTICE = '정기회의',
  JT_VOLUNTEER_FORM = '봉사신청',
}

export enum ColoredText {
  COMPLETED_COLOR = '#519EA6',
  INCOMPLETE_COLOR = '#F36523',
}

export enum Qualification {
  ASPIRANT_KOR = 'ASPIRANT_KOR', // 지원자
  BASIC_MEMBER_KOR = 'BASIC_MEMBER_KOR', // 일반회원
  DHARMA_MEMBER_KOR = 'DHARMA_MEMBER_KOR', // 전법회원
  PLEDGED_KOR = 'PLEDGED_KOR', // 결사회원
}

export enum QualificationResult {
  APPROVED = 'APPROVED', // 승인
  NOT_APPROVED = 'NOT_APPROVED', // 미승인
  PENDING = 'PENDING', // 승인대기중
}

export enum QulificationStatus {
  APPROVED = 'APPROVED', // 승인
  NOT_APPROVED = 'NOT_APPROVED', // 미승인
  PENDING = 'PENDING', // 승인대기중
}

export enum VolApplyStatusCode {
  PROGRESS = 'PROGRESS',     // 진행중
  ACTIVE = 'ACTIVE',         // 활동
  INACTIVE = 'INACTIVE',     // 비활동
  COMPLETED = 'COMPLETED',   // 회향
}

export const VOL_APPLY_STATUS_LABELS: Record<VolApplyStatusCode, string> = {
  [VolApplyStatusCode.PROGRESS]: '진행중',
  [VolApplyStatusCode.ACTIVE]: '활동',
  [VolApplyStatusCode.INACTIVE]: '비활동',
  [VolApplyStatusCode.COMPLETED]: '회향',
};

export enum ErrorCode {
  NOT_FOUND = '404',
  INTERNAL_SERVER_ERROR = '500',
  FORBIDDEN = '403',
  UNAUTHORIZED = '401',
  BAD_REQUEST = '400',
}
